import {i18n} from '@yourcoach/i18n';

import type {FileApiModel} from '../../../api/media/file';
import type {Nullable} from '../../utility-types';

export type CreateFileConfig = {
  categories: FileCategory[];
  id: string;
  mimetype?: string;
  name: string;
  size: number;
  url: Nullable<string>;
};

export type FileCategory =
  | 'audio'
  | 'document'
  | 'image'
  | 'video'
  | (string & {});

export const createFile = ({
  categories,
  id,
  mimetype,
  name,
  size,
  url,
}: CreateFileConfig) =>
  ({
    _id: id,
    categories,
    src: {
      original: {
        filename: name,
        mimetype,
        size,
        url,
      },
    },
  }) as unknown as FileApiModel;

export const createFileNotFound = () =>
  ({
    categories: [],
    src: {
      original: {
        filename: i18n.t('shared:label.file_not_found'),
        size: 0,
        url: '',
      },
    },
  }) as unknown as FileApiModel;
